import React from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';

import Main from './components/Main';
import Webinar from './components/Webinar';
import ScrollToTop from './components/ScrollTop';
import Join from './singup/Join';
import JoinForm from './singup/JoinForm';
import Choose from './singup/Choose';
import ConfirmSignup from './singup/ConfirmSignup';
import LoginPage from './singup/Login';
import ForgotPW from './singup/ForgotPW';
import MyPage from './mypage/MyPage';
import ReviewWin from './mypage/ReviewWin';
import RegistrationReceipt from './mypage/RegistrationReceipt';
import CertificateWin from './mypage/CertificateWin';
import WelcomePage from './about/Welcome';
import Committee from './about/Committee';
import Overview from './about/Overview';
import Bbs from './about/Bbs';
import BbsDetail from './about/BbsDetail';
import ProgramList from './program/ProgramList';
import ProgramListCopy from './program/ProgramListCopy';
// import ProgramTemp from './program/ProgramTemp';
import ProgramPage from './program/ProgramPage';
import InvitedSpeakers from './program/InvitedSpeakers';
import InvitedSpeakersCopy from './program/InvSpeakersCopy';
import FreePaperGuide from './freepaper/FreePaperGuide';
import PresentationGuide from './freepaper/PresentationGuide';
import FreePaperSubmission from './freepaper/FreePaperSubmission';
import FreePaperPreview from './freepaper/FreePaperPreview';
import RegistrationGuide from './registration/RegistrationGuide';
import RegistrationSubmission from './registration/RegistrationSubmission';
import RegistrationSubmissionCopy from './registration/RegistrationSubmissionCopy';

import GalaDinner from './registration/GalaDinner';
// import OnsiteRegistrationSubmission from './registration/OnsiteRegistrationSubmission';
import SpeakerSubmission from './speaker/SpeakerSubmission';
import SpeakerPreview from './speaker/SpeakerPreview';
import SpeakerGuide from './speaker/SpeakerGuide';
import ExhibiApplication from './sponsor/ExhibiApplication';
import SponsorInfo from './sponsor/SponsorInfo';
import SponsorLogin from './sponsor/SponsorLogin';

import SponsorList from './sponsor/SponsorList';
import DashboardPage from './admin/Dashboard';
import UserListPage from './admin/Member';
import PaperListPage from './admin/Paper';
import PaperPreview from './admin/PaperPreview';
import SponsorListPage from './admin/Sponsor';
import SpeakerListPage from './admin/Speaker';
import RegListPage from './admin/Registration';
import ResendPage from './admin/Resend';
import SpeakerPreviewAdmin from './admin/SpeakerPreview';
import PaperReviewPage from './admin/PaperReview';
// import RegistaionStatus from './admin/chart/RegistaionStatus';
import RegistrationStatusTemp from './admin/chart/RegistrationStatusTemp';
// import MemberStatus from './admin/chart/MemberStatus';
import MemberStatusTemp from './admin/chart/MemberStatusTemp';
// import PaperStatus from './admin/chart/PaperStatus';
import PaperStatusTemp from './admin/chart/PaperStatusTemp';
import SpeakerStatus from './admin/chart/SpeakerStatus';
import SponsorStatus from './admin/chart/SponsorStatus';
import PayResult from './common/PayResult';

import ComingSoon from './components/ComingSoon';
import Preparing from './components/Preparing';

import Korea from './info/Korea';
import Venue from './info/Venue';
import Accommodation from './info/Accommodation';
import Visa from './info/Visa';
import GettingVenue from './info/GvRenew';
import Covid from './info/Covid';

import SocialEvent from './program/SocialEvent';
import PdfDownload from './singup/PdfDownload';

// const moment = require('moment');

export default (props) => {
  // const today = moment().tz('Asia/Seoul');
  return (
    <HashRouter>
      <ScrollToTop>
        <Switch>
          {/* <Route exact path="/" component={ComingSoon} /> */}
          {/* 개발시에만 route 주석 풀어주세요. 빌드시 주석 !!! */}
          <Route exact path="/" component={Main} />
          <Route exact path="/comingsoon" component={ComingSoon} />
          <Route exact path="/main" component={Main} />
          <Route exact path="/signin" component={LoginPage} />
          <Route exact path="/choose" component={Choose} />
          <Route exact path="/signup" component={Join} />
          <Route exact path="/userinfo" component={JoinForm} />
          <Route exact path="/confirm_signup" component={ConfirmSignup} />
          <Route exact path="/findpw" component={ForgotPW} />
          <Route exact path="/mypage" component={MyPage} />
          <Route exact path="/review" component={ReviewWin} />
          <Route exact path="/bbs" component={Bbs} />
          <Route exact path="/bbs_detail" component={BbsDetail} />
          <Route exact path="/overview" component={Overview} />
          <Route exact path="/welcome" component={WelcomePage} />
          <Route exact path="/committee" component={Committee} />
          <Route exact path="/program/list" component={ProgramList} />
          <Route exact path="/program/listCopy" component={ProgramListCopy} />
          <Route exact path="/program/program" component={ProgramPage} />
          <Route exact path="/program/speakers" component={InvitedSpeakers} />
          <Route exact path="/program/speakersCopy" component={InvitedSpeakersCopy} />
          <Route exact path="/program/socialevent" component={SocialEvent} />

          <Route exact path="/paper/guide" component={FreePaperGuide} />
          <Route exact path="/paper/presentation" component={PresentationGuide} />
          <Route exact path="/paper/submission" component={FreePaperSubmission} />
          <Route exact path="/paper/preview" component={FreePaperPreview} />
          {/* 등록 */}
          <Route exact path="/registration/guide" component={RegistrationGuide} />
          <Route exact path="/registration/submission" component={RegistrationSubmission} />
          <Route exact path="/after" component={RegistrationSubmissionCopy} />

          {/*<Route exact path="/registration/submission" component={OnsiteRegistrationSubmission} />*/}
          <Route exact path="/registration/receipt" component={RegistrationReceipt} />
          <Route exact path="/registration/certificate" component={CertificateWin} />
          <Route exact path="/registration/galadinner" component={GalaDinner} />

          <Route exact path="/speaker/submission" component={SpeakerSubmission} />
          <Route exact path="/speaker/guide" component={SpeakerGuide} />
          <Route exact path="/speaker/preview" component={SpeakerPreview} />
          <Route exact path="/sponsor/information" component={SponsorInfo} />
          <Route exact path="/payResult" component={PayResult} />
          <Route exact path="/sponsor/application" component={ExhibiApplication} />
          <Route exact path="/sponsor/signin" component={SponsorLogin} />

          <Route exact path="/webinar" component={Webinar} />
          <Route exact path="/Preparing" component={Preparing} />
          {/*<Route exact path="/sponsor/boothinfo" component={BoothInfo} />*/}
          <Route exact path="/sponsor/list" component={SponsorList} />
          {/* ======== ADMIN ======== */}
          <Route exact path="/admin" component={DashboardPage} />
          <Route exact path="/admin/member" component={UserListPage} />
          <Route exact path="/admin/resend" component={ResendPage} />
          <Route exact path="/admin/paper" component={PaperListPage} />
          <Route exact path="/admin/paper/Preview" component={PaperPreview} />
          <Route exact path="/admin/paper/review" component={PaperReviewPage} />
          <Route exact path="/admin/sponsor" component={SponsorListPage} />
          <Route exact path="/admin/speaker" component={SpeakerListPage} />
          <Route exact path="/admin/speaker/Preview" component={SpeakerPreviewAdmin} />
          <Route exact path="/admin/registration" component={RegListPage} />
          {/* <Route exact path="/admin/registrationStatus" component={RegistaionStatus} /> */}
          <Route exact path="/admin/registrationStatus" component={RegistrationStatusTemp} />
          {/* <Route exact path="/admin/memberStatus" component={MemberStatus} /> */}
          <Route exact path="/admin/memberStatus" component={MemberStatusTemp} />
          <Route exact path="/admin/paperStatus" component={PaperStatusTemp} />
          <Route exact path="/admin/speakerStatus" component={SpeakerStatus} />
          <Route exact path="/admin/sponsorStatus" component={SponsorStatus} />

          {/* General Information */}
          <Route exact path="/info/korea" component={Korea} />
          <Route exact path="/info/venue" component={Venue} />
          <Route exact path="/info/gettingvenue" component={GettingVenue} />
          <Route exact path="/info/accommodation" component={Accommodation} />
          <Route exact path="/info/visa" component={Visa} />
          <Route exact path="/info/covid" component={Covid} />

          {/* PDF Download site */}
          <Route exact path="/downloads" component={PdfDownload} />
        </Switch>
      </ScrollToTop>
    </HashRouter>
  );
};
